import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataset = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.60496 25.3951H15.321V18.679H8.60496V25.3951ZM18.679 25.3951H25.3951V18.679H18.679V25.3951ZM8.60496 15.321H15.321V8.60496H8.60496V15.321ZM18.679 15.321H25.3951V8.60496H18.679V15.321ZM5.24694 32.1111C4.32348 32.1111 3.53323 31.7826 2.87618 31.1256C2.21912 30.4685 1.89004 29.6777 1.88892 28.7531V5.24694C1.88892 4.32348 2.218 3.53323 2.87618 2.87618C3.53435 2.21912 4.3246 1.89004 5.24694 1.88892H28.7531C29.6766 1.88892 30.4674 2.218 31.1256 2.87618C31.7837 3.53435 32.1123 4.3246 32.1111 5.24694V28.7531C32.1111 29.6766 31.7826 30.4674 31.1256 31.1256C30.4685 31.7837 29.6777 32.1123 28.7531 32.1111H5.24694ZM5.24694 28.7531H28.7531V5.24694H5.24694V28.7531Z",
		fill: "currentColor"
	})
});
export default SvgDataset;
